import api from './api';

export type AssistantScope = 'quote:read' | 'quote:write' | 'policy:read' | 'posp:read' | 'posp:write';

export interface AssistantKey {
  id: string;
  name: string;
  /** polmcp_<prefix>_… — the key itself never comes back after creation. */
  display_key: string;
  scopes: AssistantScope[];
  rate_limit_per_minute: number;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
  revoke_reason: string;
  is_active: boolean;
  owner_name: string;
  owner_role: string;
}

export interface CreatedAssistantKey extends AssistantKey {
  /** The full key. Returned once, by the create call only. */
  key: string;
}

export interface AssistantServerInfo {
  url: string;
  scopes: AssistantScope[];
  can_create: boolean;
  reason: string;
  max_active_keys: number;
}

export interface AssistantCall {
  id: string;
  created_at: string;
  tool: string;
  status: string;
  error_code: string;
  quote_request_id: string | null;
  duration_ms: number;
}

export const assistantService = {
  async getServer(): Promise<AssistantServerInfo> {
    const { data } = await api.get('/assistants/server/');
    return data;
  },
  async listKeys(): Promise<AssistantKey[]> {
    const { data } = await api.get('/assistants/keys/');
    return data;
  },
  async createKey(name: string): Promise<CreatedAssistantKey> {
    const { data } = await api.post('/assistants/keys/', { name });
    return data;
  },
  async revokeKey(id: string): Promise<AssistantKey> {
    const { data } = await api.post(`/assistants/keys/${id}/revoke/`);
    return data;
  },
  async listBrokerKeys(): Promise<AssistantKey[]> {
    const { data } = await api.get('/assistants/broker-keys/');
    return data;
  },
  async revokeBrokerKey(id: string, reason: string): Promise<AssistantKey> {
    const { data } = await api.post(`/assistants/broker-keys/${id}/revoke/`, { reason });
    return data;
  },
  async listBrokerKeyCalls(id: string): Promise<AssistantCall[]> {
    const { data } = await api.get(`/assistants/broker-keys/${id}/calls/`);
    return data;
  },
};
